var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProductListSlider',{attrs:{"config":_vm.config,"products":_vm.filteredProducts,"categoryBlockName":'CrmProductSlider'}})
}
var staticRenderFns = []

export { render, staticRenderFns }